import AxiosJob from '@/services/api/job/axios_job'

export default {
  createJobInitiator: (data) => {
    return AxiosJob.post('job-initiator', data)
  },

  getJobInitiatorsFromJobDefinition: (jobDefinitionId) => {
    return AxiosJob.get(`job-initiator/by-job-definition/${jobDefinitionId}`)
  },

  getUserJobsInitiator: () => {
    return AxiosJob.get(`job-initiator/by-current-user`)
  },

  getJobInitiator: (jobInitiatorId) => {
    return AxiosJob.get(`job-initiator/${jobInitiatorId}`)
  },

  deleteJobInitiator: (params) => {
    return AxiosJob.delete(`job-initiator`, { params })
  }
}
